var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g2, _path12, _path13, _path14, _path15, _path16, _g3, _g4, _path17, _g5, _g6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHundred(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 51,
    viewBox: "0 0 56 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 38H33V41.2727L28 44L23 41.2727V38Z",
    fill: "#814E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.612 11.3825C44.719 10.6628 45.955 10.3112 47.249 10.1328C48.835 9.9141 50.7 9.8704 52.128 10.7604C53.304 11.4932 54.167 12.97 53.973 14.433C53.643 16.9201 51.316 18.7725 49.476 20.0647C48.324 20.8735 47.225 21.429 46.007 22.1056C45.134 22.5903 43.96 23.1994 43.166 23.8464C41.943 24.8441 41.089 26.313 41.332 27.9829C41.515 29.2443 42.371 30.06 43.601 29.9965C44.126 29.9695 44.58 29.7543 45.027 29.5054",
    stroke: "#E89007",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.388 11.3825C11.281 10.6628 10.045 10.3112 8.751 10.1328C7.165 9.9141 5.29999 9.8704 3.87199 10.7604C2.69599 11.4932 1.83299 12.97 2.02699 14.433C2.35699 16.9201 4.684 18.7725 6.524 20.0647C7.676 20.8735 8.77499 21.429 9.99299 22.1056C10.866 22.5903 12.04 23.1994 12.834 23.8464C14.057 24.8441 14.911 26.313 14.668 27.9829C14.485 29.2443 13.629 30.06 12.399 29.9965C11.874 29.9695 11.42 29.7543 10.973 29.5054",
    stroke: "#E89007",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 7H45V19L44.5 22.5L43 26C43 26 40.351 30.8798 38 33.5C36.246 35.4554 33 38 33 38H28H23C23 38 19.754 35.4554 18 33.5C15.649 30.8798 13 26 13 26L11.5 22.5L11 19V7Z",
    fill: "#E89007"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 41C19 40.4477 19.448 40 20 40H36C36.552 40 37 40.4477 37 41V45C37 45.5523 36.552 46 36 46H20C19.448 46 19 45.5523 19 45V41Z",
    fill: "#5E2C26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44C16 42.8954 16.895 42 18 42H38C39.105 42 40 42.8954 40 44V45C40 46.1046 39.105 47 38 47H18C16.895 47 16 46.1046 16 45V44Z",
    fill: "#82534E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 47C15 46.4477 15.448 46 16 46H40C40.552 46 41 46.4477 41 47V50C41 50.5523 40.552 51 40 51H16C15.448 51 15 50.5523 15 50V47Z",
    fill: "#5E2C26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 47H40",
    stroke: "#2D0E0B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47H15C14.4477 47 14 47.4477 14 48V49C14 49.5523 14.4477 50 15 50H41C41.5523 50 42 49.5523 42 49V48C42 47.4477 41.5523 47 41 47Z",
    fill: "#5E2C26"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32 43H24C23.4477 43 23 43.4477 23 44C23 44.5523 23.4477 45 24 45H32C32.5523 45 33 44.5523 33 44C33 43.4477 32.5523 43 32 43Z",
    fill: "#E1B469"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_113",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 7,
    width: 35,
    height: 31
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hue"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.5H45V19L44.5 22.5L43 26C43 26 40.351 30.8798 38 33.5C36.246 35.4554 33 38 33 38H28H23C23 38 33.125 37.6879 39.5 26C42.5 20.5 45 7.5 45 7.5C45 7.5 32 8.5 20.5 12C9 15.5 11 19 11 19V7.5Z",
    fill: "#814E00"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_113)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55 -7H-9V50H55V-7Z",
    fill: "#814E00",
    fillOpacity: 0.25
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 2C47.5 2 47.5 7 44 7",
    stroke: "#E89007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 2H10.58C7.14 2 7.14 7 10.58 7C11.399 7 19.23 7 44 7",
    stroke: "#E89007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.086 4.47346H44.444",
    stroke: "#E89007",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_113",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 1,
    width: 41,
    height: 7
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44 2C47.5 2 47.5 7 44 7",
    stroke: "#E89007"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44 2H10.58C7.14 2 7.14 7 10.58 7C11.399 7 19.23 7 44 7",
    stroke: "#E89007"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.086 4.47346H44.444",
    stroke: "#E89007",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_113)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_113",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: -4,
    width: 44,
    height: 15
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 0.76251C53.3 7.96251 21.167 7.09584 4 5.76251V8.76251L40.5 10.2625L48 5.76251L46 -1.73749C41.833 -3.90416 35.7 -6.43749 44.5 0.76251Z",
    fill: "#211E1E"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_113)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62 -18.7375H-2V38.2625H62V-18.7375Z",
    fill: "#814E00",
    fillOpacity: 0.25
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.642 2.82024C31.46 0.710381 33.833 -0.336801 35.943 0.481291C38.053 1.29939 39.1 3.67297 38.282 5.78284L34.215 16.2728C33.633 17.7719 31.678 18.1352 30.597 16.9449C30.139 16.4409 29.471 16.1818 28.793 16.2455C27.193 16.396 25.993 14.8093 26.574 13.3102L30.642 2.82024Z",
    fill: "#BB3027"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_1_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.285 2.99233C25.467 0.88247 23.094 -0.164713 20.984 0.65338C18.874 1.47148 17.827 3.84506 18.645 5.95492L22.712 16.4449C23.294 17.944 25.249 18.3073 26.33 17.117C26.788 16.613 27.456 16.3539 28.134 16.4176C29.735 16.5681 30.934 14.9814 30.353 13.4823L26.285 2.99233Z",
    fill: "#BB3027"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10L29.377 11.3083L31.09 10.4894L31.995 12.1591L33.878 11.9098L34.223 13.7775L36.09 14.1221L35.841 16.0049L37.511 16.9098L36.692 18.6234L38 20L36.692 21.3766L37.511 23.0902L35.841 23.9951L36.09 25.8779L34.223 26.2225L33.878 28.0902L31.995 27.8409L31.09 29.5106L29.377 28.6917L28 30L26.623 28.6917L24.91 29.5106L24.005 27.8409L22.122 28.0902L21.777 26.2225L19.91 25.8779L20.159 23.9951L18.489 23.0902L19.308 21.3766L18 20L19.308 18.6234L18.489 16.9098L20.159 16.0049L19.91 14.1221L21.777 13.7775L22.122 11.9098L24.005 12.1591L24.91 10.4894L26.623 11.3083L28 10Z",
    fill: "#A86600"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 20C36 24.4183 32.418 28 28 28C23.582 28 20 24.4183 20 20C20 15.5817 23.582 12 28 12C32.418 12 36 15.5817 36 20Z",
    fill: "#E1B469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 20C35.5 24.1421 32.142 27.5 28 27.5C23.858 27.5 20.5 24.1421 20.5 20C20.5 15.8579 23.858 12.5 28 12.5C32.142 12.5 35.5 15.8579 35.5 20Z",
    stroke: "#E89007"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.32 22L24.359 21.6758L23.336 21.5547V17.3711H23.227L21.586 17.6719L21.562 17.9727H22.539V21.5273L21.508 21.7109L21.477 22H24.32ZM26.766 22.1055C27.049 22.1055 27.312 22.0312 27.555 21.8828C27.797 21.7318 27.995 21.4779 28.148 21.1211C28.305 20.7643 28.383 20.2943 28.383 19.7109C28.383 19.1615 28.316 18.707 28.184 18.3477C28.051 17.9883 27.866 17.724 27.629 17.5547C27.392 17.3854 27.112 17.3008 26.789 17.3008C26.487 17.3008 26.21 17.388 25.957 17.5625C25.707 17.7344 25.505 18.0013 25.352 18.3633C25.201 18.7253 25.125 19.1745 25.125 19.7109C25.125 20.599 25.273 21.2201 25.57 21.5742C25.867 21.9284 26.266 22.1055 26.766 22.1055ZM26.758 17.7109C26.961 17.7109 27.118 17.7839 27.23 17.9297C27.342 18.0729 27.421 18.2878 27.465 18.5742C27.509 18.8607 27.531 19.2396 27.531 19.7109C27.531 20.1849 27.508 20.5677 27.461 20.8594C27.417 21.151 27.341 21.3685 27.234 21.5117C27.128 21.6549 26.979 21.7266 26.789 21.7266C26.57 21.7266 26.401 21.6549 26.281 21.5117C26.164 21.3685 26.082 21.1549 26.035 20.8711C25.991 20.5846 25.969 20.2018 25.969 19.7227C25.969 19.2513 25.991 18.8711 26.035 18.582C26.082 18.293 26.163 18.0755 26.277 17.9297C26.392 17.7839 26.552 17.7109 26.758 17.7109ZM30.602 22.1055C30.885 22.1055 31.148 22.0312 31.391 21.8828C31.633 21.7318 31.831 21.4779 31.984 21.1211C32.141 20.7643 32.219 20.2943 32.219 19.7109C32.219 19.1615 32.152 18.707 32.02 18.3477C31.887 17.9883 31.702 17.724 31.465 17.5547C31.228 17.3854 30.948 17.3008 30.625 17.3008C30.323 17.3008 30.046 17.388 29.793 17.5625C29.543 17.7344 29.341 18.0013 29.188 18.3633C29.036 18.7253 28.961 19.1745 28.961 19.7109C28.961 20.599 29.109 21.2201 29.406 21.5742C29.703 21.9284 30.102 22.1055 30.602 22.1055ZM30.594 17.7109C30.797 17.7109 30.954 17.7839 31.066 17.9297C31.178 18.0729 31.257 18.2878 31.301 18.5742C31.345 18.8607 31.367 19.2396 31.367 19.7109C31.367 20.1849 31.344 20.5677 31.297 20.8594C31.253 21.151 31.177 21.3685 31.07 21.5117C30.964 21.6549 30.815 21.7266 30.625 21.7266C30.406 21.7266 30.237 21.6549 30.117 21.5117C30 21.3685 29.918 21.1549 29.871 20.8711C29.827 20.5846 29.805 20.2018 29.805 19.7227C29.805 19.2513 29.827 18.8711 29.871 18.582C29.918 18.293 29.999 18.0755 30.113 17.9297C30.228 17.7839 30.388 17.7109 30.594 17.7109ZM33.566 20.4023V21.2773L34.004 21.3203L33.996 20.4023H34.809L34.855 20.0078H33.996L33.992 19.1523L33.566 19.1055V20.0078H32.75L32.703 20.4023H33.566Z",
    fill: "#845000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_113",
    x: 7,
    y: 7,
    width: 42,
    height: 39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_113"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_113",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_113",
    x: 3.5,
    y: 1.5,
    width: 47.625,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_113"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_113",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1_113",
    x: 22.4252,
    y: 0.203058,
    width: 20.135,
    height: 25.4513,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_113"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_113",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_1_113",
    x: 14.3668,
    y: 0.375147,
    width: 20.1351,
    height: 25.4513,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_113"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1_113",
    result: "effect2_dropShadow_1_113"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_113",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1_113",
    x: 16,
    y: 12,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_113"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_113",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1_113",
    x: 17.477,
    y: 17.3008,
    width: 21.378,
    height: 12.8047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_113"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_113",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHundred);
export default __webpack_public_path__ + "static/media/hundred.9dde87d06adca407b168a108ed1de8fe.svg";
export { ForwardRef as ReactComponent };